export default __webpack_public_path__ + "static/product-unit-1-apple-5d1c40f2c9bee2007ee1f208a6bd1cd8.png";